import React, { Component } from 'react';
import { inject, observer, PropTypes as mobxPropTypes } from 'mobx-react';
import DataChips from '../../components/DataChips/DataChips';

const propTypes = {
  statsStore: mobxPropTypes.observableObject.isRequired,
};

class Stats extends Component {
  constructor(props) {
    super(props);
    this.fetchData = this.fetchData.bind(this);
  }

  componentWillMount() {
    this.fetchData();
  }

  async fetchData() {
    const { statsStore } = this.props;
    await statsStore.fetch();
  }

  render() {
    const { statsStore } = this.props;
    const stats = statsStore.getStats;
    let dataChips = [];
    if (stats && stats.users && stats.reports) {
      dataChips = [
        { description: 'Users', value: stats.users },
        { description: 'Reports', value: stats.reports },
      ];
    }
    return (
      <DataChips data={dataChips} />
    );
  }
}

Stats.propTypes = propTypes;
export default inject('statsStore')(observer(Stats));



// WEBPACK FOOTER //
// ./src/containers/Stats/Stats.js